import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/', label: 'Home', end: true },
  { to: '/audiobooks', label: 'Audiobooks' },
  { to: '/music', label: 'Music' },
  { to: '/movies', label: 'Movies' },
  { to: '/videos', label: 'Videos' },
  { to: '/photos', label: 'Photos' },
  { to: '/search', label: 'Search' },
];

export default function Sidebar() {
  return (
    <nav className="FV-sidebar">
      {NAV_ITEMS.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            `FV-sidebar-link${isActive ? ' FV-sidebar-link--active' : ''}`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
